import { COLORS } from '@/constants/colors';
import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';

export const GlobalStyles = createGlobalStyle`
  ${normalize}

  html,
  body {
    max-width: 100vw;
    overflow-x: clip;
  }

  body {
    background-color: ${COLORS.white};
    font-family: var(--font-urbanist), sans-serif;
  }

  a {
    text-decoration: none !important;
    color: inherit;
  }

  .grecaptcha-badge {
    z-index: 100;
  }

  .safari-no-autofill-ui input::-webkit-contacts-auto-fill-button,
  .safari-no-autofill-ui input::-webkit-credentials-auto-fill-button,
  .safari-no-autofill-ui input::-webkit-strong-password-auto-fill-button {
    visibility: hidden !important;
    display: none !important;
    pointer-events: none !important;
    height: 0 !important;
    width: 0 !important;
    margin: 0 !important;
    position: absolute;
    right: 0;
  }

  @media (max-width: 959px) {
    .grecaptcha-badge {
      visibility: hidden !important;
      opacity: 0 !important;
      pointer-events: none !important;
    }
  }

  @media (max-width: 959px) {
    body .Toastify__toast-container--top-center {
      width: calc(100vw - 10px) !important;
      max-width: 400px !important;
      left: 50% !important;
      right: auto !important;
      transform: translateX(-50%) !important;
      padding: 0 5px !important;
      margin: 0 !important;
      box-sizing: border-box !important;
    }
    body .Toastify__toast-container--top-center .Toastify__toast.toast-mobile {
      width: 100% !important;
      max-width: 100% !important;
      margin: 10px 0 0 0 !important;
      background: #fff !important;
      border-radius: 10px !important;
      color: #333 !important;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15) !important;
      box-sizing: border-box !important;
    }
    body .Toastify__toast-container--top-center .Toastify__toast.toast-mobile--success {
      border: 2px solid #2e7d32 !important;
    }
    body .Toastify__toast-container--top-center .Toastify__toast.toast-mobile .Toastify__toast-icon {
      width: 21px !important;
      height: 21px !important;
      min-width: 21px !important;
      background: transparent !important;
      color: inherit !important;
      border-radius: 0 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      margin-inline-end: 12px !important;
    }
    body .Toastify__toast-container--top-center .Toastify__toast.toast-mobile .Toastify__toast-icon svg {
      fill: none !important;
    }

    .Toastify__toast--warning {
      background: #fff !important;
      border: 2px solid #ed6c02 !important;
      border-radius: 10px !important;
      color: #333 !important;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
      margin: 10px 10px 0 10px !important;
    }
    .Toastify__toast--warning .Toastify__toast-icon {
      width: 28px !important;
      height: 28px !important;
      min-width: 28px !important;
      background: #ed6c02 !important;
      color: #fff !important;
      border-radius: 50% !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      margin-inline-end: 12px;
    }
    .Toastify__toast--warning .Toastify__toast-icon svg {
      fill: #fff !important;
    }
    .Toastify__toast--warning .Toastify__progress-bar--wrp {
      display: none !important;
    }

    .Toastify__toast--error {
      background: #fff !important;
      border: 2px solid #d32f2f !important;
      border-radius: 10px !important;
      color: #333 !important;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
      margin: 10px 10px 0 10px !important;
    }
    .Toastify__toast--error .Toastify__toast-icon {
      width: 28px !important;
      height: 28px !important;
      min-width: 28px !important;
      background: #d32f2f !important;
      color: #fff !important;
      border-radius: 50% !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      margin-inline-end: 12px;
    }
    .Toastify__toast--error .Toastify__toast-icon svg {
      fill: #fff !important;
    }
    .Toastify__toast--error .Toastify__progress-bar--wrp {
      display: none !important;
    }
  }

  * {
    scrollbar-width: thin;
    scrollbar-color: #4a4a4f60 #f4f4f5;
  }

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #f4f4f5;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #4a4a4f60;
  }

  .scroll-hover-behavior-bottom {
    overflow-x: auto;
    padding-bottom: 4px;
    margin-bottom: -4px;
  }

  .scroll-hover-behavior-bottom::-webkit-scrollbar-track {
    background: transparent;
  }

  .scroll-hover-behavior-bottom::-webkit-scrollbar-thumb {
    background: transparent;
  }

  .scroll-hover-behavior-bottom:hover::-webkit-scrollbar-track {
    background: #f4f4f5;
  }

  .scroll-hover-behavior-bottom:hover::-webkit-scrollbar-thumb {
    background: #4a4a4f60;
  }

  /* Mobile Firefox draws the styled page scrollbar inline instead of overlaying
     it, so it never goes away (PROP-1264). */
  @media (max-width: 959px) {
    html {
      scrollbar-width: none;
    }
  }

.burgerBtn {
  position: relative;
  display: block;
  width: 24px;
  height: 24px;
  margin: 0;
  border-radius: 100%;
  transition-duration: 0.3s;

  &:hover {
    cursor: pointer;
    .icon-left, .icon-right {
      &, &::before, &::after {
        background-color: ${COLORS['secondary/500']};
      }
    }
  }

  .icon-left {
    transition-duration: 0.3s;
    position: absolute;
    width: 12px;
    height: 2px;
    left: 0px;
    top: 50%;
    transform: translateY(-50%);
    background-color: ${COLORS['primary/800']};

    &::before {
      transition-duration: 0.3s;
      position: absolute;
      width: 12px;
      height: 2px;
      content: "";
      top: -8px;
      left: 0;
      background-color: ${COLORS['primary/800']};
    }

    &::after {
      transition-duration: 0.3s;
      position: absolute;
      width: 12px;
      height: 2px;
      content: "";
      top: 8px;
      left: 0;
      background-color: ${COLORS['primary/800']};
    }
  }

  .icon-right {
    transition-duration: 0.3s;
    position: absolute;
    width: 12px;
    height: 2px;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    background-color: ${COLORS['primary/800']};

    &::before {
      transition-duration: 0.3s;
      position: absolute;
      width: 12px;
      height: 2px;
      content: "";
      top: -8px;
      left: 0;
      background-color: ${COLORS['primary/800']};
    }

    &::after {
      transition-duration: 0.3s;
      position: absolute;
      width: 12px;
      height: 2px;
      content: "";
      top: 8px;
      left: 0;
      background-color: ${COLORS['primary/800']};
    }
  }

  &.open {
    .icon-left, .icon-right {
      background: transparent;

      &::before {
        transform: rotateZ(45deg) scaleX(1.4) translate(1px, 1px);
      }

      &::after {
        transform: rotateZ(-45deg) scaleX(1.4) translate(1px, -1px);
      }
    }

    .icon-right {
      &::before {
        transform: rotateZ(-45deg) scaleX(1.4) translate(-1px, 1px);
      }

      &::after {
        transform: rotateZ(45deg) scaleX(1.4) translate(-1px, -1px);
      }
    }
  }
};
`;
